module.exports = __webpack_public_path__ + "img/logo-edasinvoize-dark.c58fa10a.webp";